@if (modal.options.data?.content$ | async; as content) {
  <div class="modal">
    <div class="modal__content">
      <div class="window">
        <i class="window__close icon-close" (click)="modal.close()"></i>
        <div class="body">
          <div class="body__title" [innerHTML]="content[0]?.Title | safe : 'html'"></div>
          <div class="body__content" [innerHTML]="content[0]?.Content | safe : 'html'"></div>
        </div>
      </div>
    </div>
  </div>
}

